import React, { useState } from "react";
import { connect } from "react-redux";
import { billing as actions } from "actions";
import { createOptions } from "./Card_Element";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js"; // Added useElements
import Message from "components/message";
import Buttons from "components/elements/Buttons";
import Button from "components/elements/Button";

function AuthorizeCard({
  user,
  messages,
  locale,
  finalizePaymentMethod,
  history,
}) {
  const stripe = useStripe();
  const elements = useElements(); // Hook to get the Element instance

  const [validation, setValidation] = useState({ error: false, message: "" });
  const [formComplete, setFormComplete] = useState(false);
  const [authFail, setAuthFail] = useState(false);
  const [processing, setProcessing] = useState(false); // New: Handle loading state

  function handleChange(event) {
    // Stripe provides the error object directly in the event
    setValidation({
      error: !!event.error,
      message: event.error ? event.error.message : "",
    });
    setFormComplete(event.complete);
  }

async function submit(ev) {
  ev.preventDefault();
  if (!stripe || !elements) return;

  setProcessing(true);
  const cardElement = elements.getElement(CardElement);

  try {
    const result = await stripe.confirmCardSetup(user.stripeClientSecret, {
      payment_method: {
        card: cardElement,
        billing_details: { email: user.email },
      },
    });

    if (result.error) {
      // Jos virhe on "tyyppiä", että intent on jo onnistunut, voimme jatkaa
      if (result.error.setup_intent && result.error.setup_intent.status === 'succeeded') {
        finalizePaymentMethod(result.error.setup_intent, () => {
          history.push("/userhome/user_account/subscription");
        });
      } else {
        console.error("Card setup failed:", result.error.message);
        setValidation({ error: true, message: result.error.message });
        setAuthFail(true);
        setProcessing(false);
      }
    } else if (result.setupIntent) {
      // Normaali onnistuminen
      finalizePaymentMethod(result.setupIntent, () => {
        setProcessing(false);
        history.push("/userhome/user_account/subscription");
      });
    }
  } catch (err) {
    console.error("Odottamaton virhe:", err);
    setProcessing(false);
  }
}

  return (
    <>
      {authFail && <Message warning message="authorizationFailed" />}
      <Message warning message="requiresPaymentMethod" />
      
      <div className="checkout notification" style={{ padding: 8 }}>
        <div className="columns is-2 is-variable is-flex-desktop is-mobile is-multiline">
          <div className="column is-6-desktop is-12-mobile is-flex-desktop">
            <div className="box" style={{ width: "100%" }}>
              <p>{messages.labels.enterCardDetails[locale]}</p>
              <br />
              <CardElement
                onChange={handleChange}
                options={createOptions()}
              />
              {validation.error && (
                <p className="is-danger help" style={{ color: 'red', marginTop: '5px' }}>
                  {validation.message}
                </p>
              )}
            </div>
          </div>
          
          <div className="column is-6-desktop is-12-mobile is-flex-desktop">
            <div className="box" style={{ width: "100%" }}>
              <Buttons>
                <Button
                  className={`is-link is-fullwidth ${processing ? 'is-loading' : ''}`}
                  group="stripe"
                  name="updateCard"
                  onClick={submit}
                  // Disable if processing, if there is an error, or if fields aren't filled
                  disabled={!stripe || processing || validation.error || !formComplete}
                />
              </Buttons>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// Ensure your actions are properly mapped if 'actions' is an object of functions
export default connect(null, actions)(AuthorizeCard);